module.exports = __webpack_public_path__ + "static/img/icomoon.95c7c62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon/fonts/icomoon.svg?3oykl7
// module id = YEPc
// module chunks = 6